"use client";

import { useEffect, useState } from "react";
import CommonHeader from "@/components/common/CommonHeader";
import MyCartItems from "@/components/cart/MyCartItems";
import MyCartOffers from "@/components/cart/MyCartOffers";
import MyCartSummary from "@/components/cart/MyCartSummary";
import MyCartModal from "@/components/cart/MyCartModal";
import SavingsCorner from "@/components/cart/SavingsCorner";
import ApplyCouponDrawer from "@/components/cart/ApplyCouponDrawer";
import { AddressModal } from "@/components/common/AddressModal";
import CartAddressLabel from "@/components/cart/CartAddressLabel";
import useCommonStore from "@/store/commonStore";
import { useRouter } from "next/navigation";
import useCartStore from "@/store/cartStore";
import { ArrowLeft, Check } from "lucide-react";
import useOrderStore from "@/store/orderStore";
import { toast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { Stepper } from "@/components/common/Stepper";
import QuantityPopup from "@/components/cart/QuantityPopup";
import Image from "next/image";
import { GTMUpdateOrderSummaryHandler } from "@/lib/analytics";

export default function MyCartPage() {
  const { isAuth, translations } = useCommonStore();
  const [showModal, setShowModal] = useState(false);
  const [showCouponDrawer, setShowCouponDrawer] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState<string | null>(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [warningPopup, setWarningPopup] = useState<boolean>(false);
  const [outOfStockItems, setOutOfStockItems] = useState<Record<string, any>[]>(
    []
  );

  const router = useRouter();
  const { cart } = useCartStore();
  const { updateUserOrderSummary } = useOrderStore();

  // const applyCoupon = (code: string) => {
  //   if (!isAuth) {
  //     router.push("/login?redirect=/mycart")
  //   } else {
  //     setAppliedCoupon(code)
  //     setShowCouponDrawer(false)
  //   }
  // }
  const updateOrderSummary = async (items?: Record<string, any>[]) => {
    let itm=cart?.map((itm=>({
      item_id: itm.pdt_id,
      item_variant: itm?.variant_id,
      quantity: itm.quantity,
    })))
    GTMUpdateOrderSummaryHandler({
      items: itm || []
    })
    const result = await updateUserOrderSummary(items ? { items } : undefined);
    if (result?.status) {
      router.push("/checkout");
    } else if (!result?.status && result?.data?.out_of_stock_items) {
      setOutOfStockItems(result?.data?.out_of_stock_items);
      setWarningPopup(true);
    } else {
      toast({
        title: "Error",
        description: result?.message || result?.error,
        variant: "destructive",
      });
    }
  };

  const steps = [
    { id: 1, name: translations["cart"] || "Cart", completed: true },
    {
      id: 2,
      name: translations["ordr_smmry"] || "Order Summary",
      completed: true,
    },
    { id: 3, name: translations["pymnt"] || "Payment", completed: true },
  ];

  const removeOutOfStockItems = () => {
    const updatedItems = cart.filter(
      (item) =>
        !outOfStockItems.some(
          (oi) => oi.pdt_id === item.pdt_id && oi.variant_id === item.variant_id
        )
    );
    return updateOrderSummary(updatedItems);
  };
  const cancelOutOfStockWarning = () => {
    setWarningPopup(false);
    router.refresh();
  };
  return (
    <>
      <CommonHeader
        style=""
        title="my_cart"
        showSearch={false}
        showCart={false}
        showBack={true}
        backPath={"/"}
        showHeart={false}
      />

      <Stepper steps={steps} currentStep={0} />
      <div className="max-w-7xl mx-auto px-4 md:px-0 pt-4 pb-24 md:py-8 flex flex-col md:flex-row gap-4 md:gap-8">
        <div className="flex-1">
          <MyCartItems translations={translations} type="cart" />
          {/* <MyCartOffers /> */}
        </div>
        <div
          className={`flex-1 fixed md:relative left-0 right-0 bottom-0 z-30 bg-white flex gap-2 p-4 md:p-0 transition-transform duration-300 h-fit shadow md:shadow-none mt-0 md:mt-8`}
        >
          <Button
            variant="outline"
            onClick={() => router.push("/products")}
            className="flex-1 border rounded px-4 py-3 text-base md:text-lg font-medium"
          >
            {translations["shop_more"] || "Shop more"}
          </Button>
          <Button
            onClick={() => {
              if (isAuth) {
                updateOrderSummary();
              } else {
                router.push(`/login?redirect=${encodeURIComponent("/mycart")}`);
              }
            }}
            className="flex-1 bg-primary hover:bg-primary/90 text-white rounded-lg px-4 py-3 text-base md:text-lg font-medium"
          >
            {translations["continue"] || "Continue"}
          </Button>
        </div>
      </div>
      <MyCartModal open={showModal} onClose={() => setShowModal(false)} />
      <AddressModal
        open={showAddressModal}
        onClose={() => setShowAddressModal(false)}
      />
      <QuantityPopup
        open={warningPopup}
        onCancel={cancelOutOfStockWarning}
        onContinue={removeOutOfStockItems}
        message={`${outOfStockItems?.length} item${
          outOfStockItems?.length !== 1 ? "s are" : " is"
        } currently out of stock and will be removed from your list to continue with checkout.`}
      />
    </>
  );
}
